@if (companyId) {
  <app-edit-company-component [companyId]="+companyId" />
}
